import inputFieldWidget from "./inputFieldWidget.js";

/**
 * Hidden input field
 */
function hiddenFieldWidget(spec, my) {
	my ||= {};
	spec ||= {};

	spec.type ||= "hidden";
	return inputFieldWidget(spec, my);
}

export default hiddenFieldWidget;
